import * as React from 'react';

export interface LLCIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * LLCIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Limited Liability Company. Filed certificate document with checkmark badge.
 */
const LLCIcon: React.FunctionComponent<LLCIconProps> = ({
  className,
  size = 40,
  title = 'Limited Liability Company',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#3C3489" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#3C3489"/>
      <text x="24" y="22" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="9" fontWeight="900" fill="#3C3489" letterSpacing="0.4">LLC</text>
      <line x1="14" y1="27" x2="36" y2="27" stroke="#3C3489" strokeWidth="1.2"/>
      <line x1="14" y1="31" x2="32" y2="31" stroke="#3C3489" strokeWidth="1.2"/>
      <line x1="14" y1="35" x2="36" y2="35" stroke="#3C3489" strokeWidth="1.2"/>
      <line x1="14" y1="39" x2="28" y2="39" stroke="#3C3489" strokeWidth="1.2"/>
      <circle cx="34" cy="38" r="4" fill="#3C3489"/>
      <path d="M32 38 L33.5 39.5 L36 37" stroke="#FFFFFF" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LLCIcon;
